import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionHandlerService } from './permission-handler.service';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private permissionService: PermissionHandlerService,
    private dataService: DataService
  ) { }

  routesWithPermisssion: any[] = [
    {
      url: '/investor-admin',
      unit: 'ADMIN_PERMISSION',
      flag: 'a'
    },
    {
      url: '/home',
      unit: '',
      flag: ''
    },
    {
      url: '/admin/organization-units',
      unit: 'OU',
      flag: 'r'
    },
    {
      url: '/admin/organization-units/categories',
      unit: 'OU_CATEGORY',
      flag: 'r'
    },
    {
      url: '/admin/organization-units/types',
      unit: 'OU_TYPE',
      flag: 'r'
    },
    {
      url: '/admin/organization-units/locations',
      unit: 'OU_LOCATION',
      flag: 'r'
    },
    {
      url: '/admin/users',
      unit: 'USER_MANAGEMENT',
      flag: 'r'
    },
    {
      url: '/admin/users/roles',
      unit: 'ROLE_MANAGEMENT',
      flag: 'r'
    },
    {
      url: '/admin/users/roles/permission',
      unit: 'PERMISSION_MANAGEMENT',
      flag: 'r'
    },
    {
      url: '/admin/users/create',
      unit: 'USER_MANAGEMENT',
      flag: 'c'
    },
    {
      url: '/admin/data',
      unit: 'DATA',
      flag: 'r'
    },
    {
      url: '/admin/data/add',
      unit: 'CONTENT',
      flag: 'c'
    },
    {
      url: '/bulk',
      unit: 'DATA_BULK',
      flag: 'a'
    },
    {
      url: '/admin/data/types',
      unit: 'DATA_TYPE',
      flag: 'r'
    },
    {
      url: '/admin/data/templates',
      unit: 'DATA_TEMPLATE',
      flag: 'r'
    },
    {
      url: '/admin/data/fields',
      unit: 'DATA_FIELD',
      flag: 'r'
    },
    {
      url: '/admin/data/fields/types',
      unit: 'DATA_FIELD_TYPE',
      flag: 'r'
    },
    {
      url: '/update',
      unit: 'CONTENT_UPDATE_LOGS',
      flag: 'r'
    },
    {
      url: '/admin/users/roles/permission/add',
      unit: 'PERMISSION_MANAGEMENT',
      flag: 'c'
    },
    {
      url: '/knowledge-library',
      unit: 'KNOWLEDGE_LIBRARY',
      flag: 'r'
    },
    {
      url: '/notification',
      unit: 'VIEW_NOTIFICATIONS',
      flag: 'a'
    },
    {
      url: '/dashboard/knowledge-library',
      unit: 'KNOWLEDGE_LIBRARY',
      flag: ['c', 'u', 'd']
    },
    {
      url: '/dashboard/knowledge-library/category',
      unit: 'KNOWLEDGE_LIBRARY_CATEGORY',
      flag: 'r'
    },
    {
      url: '/admin/comments',
      unit: 'COMMENTS',
      flag: ['c', 'u', 'd']
    },
    {
      url: '/:from/tags-management',
      unit: 'SURVEY_TAGS',
      flag: 'r'
    },
    {
      url: '/knowledge-library/approval',
      unit: 'KNOWLEDGE_LIBRARY_APPROVAL',
      flag: 'a'
    },
    {
      url: '/training/request',
      unit: 'CONTINUOUS_TRAINING_REQUEST',
      flag: 'c'
    },
    {
      url: '/training/new-branch',
      unit: 'NEW_BRANCH_TRAINING',
      flag: 'r'
    },
    {
      url: '/training/skill-training',
      unit: 'SKILL_TRAINING',
      flag: 'r'
    },

    {
      url: '/training/type',
      unit: 'TRAINING_TYPE',
      flag: 'r'
    },
    {
      url: '/training/task-view',
      unit: 'CONTINUOUS_TRAINING',
      flag: 'r'
    },
    {
      url: '/admin/dashboards',
      unit: 'GRAPHS',
      flag: 'a'
    },
    {
      url: '/admin/dashboards/add',
      unit: 'GRAPHS',
      flag: 'a'
    },
    {
      url: '/assessment',
      unit: 'ASSESSMENT',
      flag: 'r'
    },
    {
      url: '/assessment/all-results',
      unit: 'ASSESSMENT',
      flag: 'r'
    },
    {
      url: '/assessment/results',
      unit: 'ASSESSMENT',
      flag: 'r'
    },
    {
      url: '/survey/results',
      unit: 'SURVEY',
      flag: 'r'
    },
    {
      url: '/assessment/topics',
      unit: 'ASSESSMENT',
      flag: 'r'
    },
    {
      url: '/survey/survey-type',
      unit: 'SURVEY_TYPE',
      flag: 'r'
    },
    {
      url: '/survey',
      unit: 'SURVEY',
      flag: 'r'
    },
    //user role with coordinator or trainer with externat.status = true
    {
      url: '/coordinator-view',
      unit: '',
      flag: ''
    },
    {
      url: '/add-external-coordinator',
      unit: 'COMPANY',
      flag: 'c'
    },
    {
      url: '/trainers',
      unit: 'TRAINER',
      flag: 'r'
    },
    {
      url: '/company',
      unit: 'COMPANY',
      flag: 'r'
    },
    {
      url: '/survey/attendance/:surveyId',
      unit: 'SURVEY',
      flag: ['c', 'u', 'd']
    },
    {
      url: '/ms/project/update',
      unit: 'MYSTERY_SHOPPER',
      flag: 'u'
    },
    {
      url: '/ms/project/add',
      unit: 'MYSTERY_SHOPPER',
      flag: 'c'
    },
    {
      url: 'all-data-view',
      unit: 'CONTENT',
      flag: 'r'
    },
    {
      url: 'search-view',
      unit: 'CONTENT',
      flag: 'r'
    },
    {
      url: 'advance-search',
      unit: 'CONTENT',
      flag: 'r'
    },
    {
      url: 'advance-search/result',
      unit: 'CONTENT',
      flag: 'r'
    },
    {
      url: 'periodic-reports',
      unit: 'PERIODIC_REPORTS',
      flag: 'r'
    },
    {
      url: 'periodic-reports',
      unit: 'CONTENT_APPROVE',
      flag: 'a'
    },{
      url: 'announcement',
      unit: 'ACCOUNCEMENTS',
      flag: 'a'
    }
  ];

  allowedUrls: string[] = [
    "/coordinator-view",
    "training/skill-training",
    "training/training-page",
    "training/training-results",
    "training/new-branch",
    "/attempt",
    "/add-question",
    "password-change",
  ];


  allowedUrlForDefaultUsers: string[] = [
    "/home",
    "list-services/",
    "training/training-page",
    "training/training-results",
    "category/search/",
    "/category/",
    "/search-view",
    "/knowledge-library",
    "/advance-search",
    "/advance-search/result",
    "/all-data-view"
  ];


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let url = state.url;
    let isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");
    let token = localStorage.getItem('token');
    let route = this.routesWithPermisssion.find((e: any) => url.includes(e.url));

    if (this.checkManager() && !!token) {
      return true
    }

    if (this.checkExternalUser()) {
      if (this.allowedUrls.some(e => url.includes(e))) {
        return true;
      }
      return this.router.parseUrl('coordinator-view');
    } else if (url.includes('coordinator-view')) {
      return this.router.parseUrl('home');
    }

    if ((route && this.haveUnitPermission(route) && isLoggedIn && token) || (this.allowedUrlForDefaultUsers.some(e => url.includes(e)) && !!localStorage.getItem('token'))) {
      return true;
    } else if (isLoggedIn) {
      return this.router.parseUrl('home');

    } else if (!token) {

      localStorage.setItem('token', 'vgIBADANBgkqhkiG9w0Bf4cb1ed61a1c4c7e920b63NnPgK64dyarqsGRlAXgkw0ByWy7pyrLkpsUHBXHnyRVpWa6HBdJ/EapLq8SXVWAZQX5P74eB535yKvVqKpz9qCtFlKafU0+a031efa5b3a0e0AASCBKgwggSkA21ecbd1c7f48263160b00e5c6gEAAlXcbyAy7HOmAZgoIBAQCnQ1bPXVWAZQX5P74eB5')
      this.getDefaultUser()


      return this.router.parseUrl('home');
    }
    return false;
  }


  checkManager() {
    let manager = localStorage.getItem('managerOus');
    manager = manager ? JSON.parse(manager) : null
    let mTrainer = localStorage.getItem('master_trainer');
    if ((manager && manager.length > 0) || (mTrainer != "undefined" && mTrainer != "null")) {
      return true
    } else {
      return false
    }
  }

  checkExternalUser() {
    let rawType = localStorage.getItem('externalUser')
    if (!!rawType) {
      let role = JSON.parse(rawType);
      return role.status;
    }
    return false;
  }

  haveUnitPermission(route: any) {
    if (route.url == '/home') {
      return true;
    } else {
      if (typeof route.flag == 'string') {
        return this.permissionService.hasPermission(route.unit, route.flag);
      } else {
        return (route.flag as Array<any>).some(e => this.permissionService.hasPermission(route.unit, e));
      }
    }
  }

  async getDefaultUser() {
    try {
      let res = await this.dataService.getData('user/get-default-user')

      if (res.error) return


      let user = res.data

      localStorage.setItem('username', `${user?.username.first} ${user?.username.middle} ${user?.username.last}`);
      localStorage.setItem('role', JSON.stringify(user?.role));
      localStorage.setItem('image', user?.image);
      this.permissionService.init()
    } catch (error) {
      console.log(error)
    }
  }


}
